export default "__VITE_ASSET__BfWrY_2N__"